import React from 'react'
import { AccreditationAimForm } from '@Root/components'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import { accreditationAimActions, accreditationAimSelectors } from '@Store/studies'
import { permissionsSelectors } from '@Store/permissions'
import { Redirect } from 'react-router-dom'
import { fieldTooltipManagerSelectors } from '@Store/fieldTooltipManager'

export const CreateAccreditationAim = ({ parentURL, onOpenDescriptionModal }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { id: engagementId, contactId } = useParams()
  const accreditationAim = useSelector(accreditationAimSelectors.accreditationAim)
  const options = useSelector(accreditationAimSelectors.options)
  const isLoading = useSelector(accreditationAimSelectors.isLoading)
  const dataCreationPermissions = useSelector(permissionsSelectors.dataCreationPermissions)
  const descriptions = useSelector(fieldTooltipManagerSelectors.studiesDescriptions).engagement_accreditation_aim

  const onCreate = data => {
    const payload = { ...data, student_id: Number(contactId) }
    dispatch(accreditationAimActions.create({ data: payload, history, engagementId, contactId }))
  }

  const onCancel = () => {
    history.goBack()
  }

  // if (!dataCreationPermissions.engagements_sub) return <Redirect to={parentURL} />
  return (
    <AccreditationAimForm
      onSave={onCreate}
      onCancel={onCancel}
      canEdit={true}
      isNew
      initialValue={accreditationAim}
      options={options}
      isLoading={isLoading}
      descriptions={descriptions}
      onOpenDescriptionModal={onOpenDescriptionModal}
    />
  )
}
